import React from 'react';
import cn from 'classnames';
import { RecordingAsset } from 'types';

import RecordingCardContainer from 'components/widgets/CardView/Recording/RecordingContainer/RecordingContainer';
import DynamicRailViewer from 'components/widgets/Rail/components/DynamicRailViewer/DynamicRailViewer';
import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import Title from 'components/widgets/Rail/components/Title/Title';
import { useApplyStyles } from 'components/widgets/Rail/hooks/useApplyStyles/useApplyStyles';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import styles from './RecordingRailContainer.module.scss';

export function RecordingRailContainer() {
  const { wrapperRef, refElementInner, componentHeight } = useRailContext();
  const { settings, data } = useWidgetContext<RecordingAsset>();

  const handleRef = useApplyStyles(settings);

  const { hasNextPage, totalCount, items } = data;

  return (
    <div ref={handleRef} className={cn(styles.container)}>
      <div ref={refElementInner}>
        <Title
          hasNextPage={Boolean(hasNextPage)}
          totalCount={totalCount}
          itemsLength={items.length}
          forwardHeaderRef={handleRef}
          railSettings={settings}
        />
        <div
          ref={wrapperRef}
          style={{
            height: componentHeight,
          }}
        >
          <DynamicRailViewer<RecordingAsset> railData={data}>
            {({ imageHeight, itemWidth, item }) => (
              <RecordingCardContainer imageHeight={imageHeight} itemWidth={itemWidth} data={item} />
            )}
          </DynamicRailViewer>
        </div>
      </div>
    </div>
  );
}
